__turbopack_context__.v({
  "cardBox": "AccountWishlist-module__zlbVLG__cardBox",
  "grid": "AccountWishlist-module__zlbVLG__grid",
});
